import { render, staticRenderFns } from "./HistoryServiceDetail.vue?vue&type=template&id=ced85502"
import script from "./HistoryServiceDetail.vue?vue&type=script&lang=js"
export * from "./HistoryServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryServiceDetail.vue?vue&type=style&index=0&id=ced85502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports